import { type ReactNode } from 'react'
import { clsx } from 'clsx'
import Header from './Header'
import Footer from './Footer'
import Tabbar from './Tabbar'
import { usePlatform } from '@/hooks'

interface LayoutProps {
  children: ReactNode
  hideHeader?: boolean
  hideFooter?: boolean
  hideTabbar?: boolean
}

export default function Layout({
  children,
  hideHeader = false,
  hideFooter = false,
  hideTabbar = false,
}: LayoutProps) {
  const platform = usePlatform()
  const isPC = platform === 'pc'
  const isApp = platform === 'app'

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      {!hideHeader && <Header />}

      <main
        className={clsx(
          'flex-1',
          !hideHeader && (isPC ? 'pt-[80px]' : 'pt-[56px]'),
          isApp && !hideTabbar && 'pb-[56px]'
        )}
      >
        {children}
      </main>

      {!hideFooter && <Footer />}
      {isApp && !hideTabbar && <Tabbar />}
    </div>
  )
}
